"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _ModalOverview = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/Overview/ModalOverview"));
var _AssetsTable = _interopRequireDefault(require("../../AssetsTable"));
var _modals = require("../../../utils/modals");
var _events = require("../../../analytics/events");
var styles = {
  "modal": "VersionInfoModal__modal__3UnSn",
  "header": "VersionInfoModal__header__39SJI",
  "body": "VersionInfoModal__body__3a2dO",
  "footer": "VersionInfoModal__footer__-HjZm",
  "title": "VersionInfoModal__title__jDCrn",
  "modal-lg": "VersionInfoModal__modal-lg__zgJ1D",
  "modalLg": "VersionInfoModal__modal-lg__zgJ1D"
}; 
require('./VersionInfoModal.css');
var VersionInfoModal = function VersionInfoModal(_ref) {
  var asset = _ref.asset,
    _ref$isPortalReArchit = _ref.isPortalReArchitectureEnabled,
    isPortalReArchitectureEnabled = _ref$isPortalReArchit === void 0 ? false : _ref$isPortalReArchit;
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    closeModal = _useModals.closeModal;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var labelId = 'version-info-modal-title';
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    renderInBody: false,
    onEsc: function onEsc() {
      return closeModal();
    },
    onClickOverlay: function onClickOverlay() {
      return closeModal();
    },
    className: (0, _classnames.default)(styles.modal, (0, _defineProperty2.default)({}, styles.modalLg, isPortalReArchitectureEnabled)),
    ariaLabelledBy: labelId
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    className: styles.header,
    testId: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: styles.title,
    id: labelId,
    "data-test-id": "version-info-title"
  }, "Version detail for ", asset.version)), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    testId: "modal-body",
    className: styles.body
  }, /*#__PURE__*/_react.default.createElement(_ModalOverview.default, {
    asset: asset
  }), /*#__PURE__*/_react.default.createElement(_AssetsTable.default, {
    onAssetClick: function onAssetClick() {
      return trackEvent(_events.EVENT_TYPES.ASSET_DEPENDENCY_CLICKED);
    },
    assets: asset.dependencies,
    title: "Dependency assets",
    caption: "Assets dependencies",
    testId: "asset-dependencies"
  })), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    testId: "modal-footer",
    className: styles.footer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "close-button",
    kind: "tertiary",
    onClick: function onClick() {
      return closeModal();
    },
    noFill: true
  }, isPortalReArchitectureEnabled ? 'Back' : 'Close')));
};
var VersionInfoModalContainer = (0, _modals.setModalName)('VersionInfoModal')(VersionInfoModal);
var _default = exports.default = VersionInfoModalContainer;
//# sourceMappingURL=VersionInfoModal.js.map